import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { DialogService } from 'primeng/api';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { Observable } from 'rxjs';
import { AuctionService } from '../auction.service';
import { LoanItem, PaginationParams } from '../models/loanItem';
import { AuctionRequestParams, ReservePriceUpdateRequestParams } from '../models/auctionRequest';
import { ChangeLogDetailsComponent } from '../change-log-details/change-log-details.component';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-auction-details',
  templateUrl: './auction-details.component.html',
  styleUrls: ['./auction-details.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [DialogService]
})

export class AuctionDetailsComponent implements OnInit {

  @ViewChild('dt') table: Table;
  data: LoanItem[];
  reservePriceRange: any[];
  loan: string;
  reservePriceRangeSelected: any;
  setEqualsCriteria: boolean;
  setRangeCriteria: boolean;
  exactReservePrice: number;
  minReservePrice: number;
  maxReservePrice: number;
  auctionForm: FormGroup;
  rangeError: boolean = false;
  cols: any[];
  expandedRows: {} = {};
  perInitialReservePriceModel: number;
  reservePriceReductionModel: number;
  newReservePriceModel: number;
  reqRuestparams = <AuctionRequestParams>{};
  counter$: Observable<number>;
  reservePriceUpdateForms = new Map();
  totalRecords: number;
  paginationParams: PaginationParams = { offset: 0, pageSize: 10, sortValue: 'LoanNumber', sortDir: 'Asc' };
  mainSearchParams: AuctionRequestParams;
  originalDataCopy: LoanItem[];
  loading: boolean;
  changeLogForm: FormGroup;
  display: boolean;
  disableSubmit: boolean;
  searchLabel: string = 'Search';

  constructor(private auctionService: AuctionService, private dialogService: DialogService) { }


  ngOnInit() {
    this.reservePriceRangeSelected = '';
    this.loan = '';
    this.reservePriceRange = [
      { label: 'Reserve Price', value: '' },
      { label: 'Equals', value: '=' },
      { label: 'Range', value: 'R' }
    ];

    // set the controls initially for two fields
    this.auctionForm = new FormGroup({
      loan: new FormControl('', null),
      ReservepriceOptions: new FormControl('', Validators.required)
    });

    // set the data fields here
    this.cols = [
      { field: 'loan', header: 'Loan #', showInHeader: true },
      { field: 'propertyId', header: 'Property ID', showInHeader: false },
      { field: 'auctionCycle', header: 'Auction Cycle', showInHeader: true },
      { field: 'auctionEndingIn', header: 'Auction Ending In', showInHeader: true },
      { field: 'highestBid', header: 'Highest Bid ($)', showInHeader: true },
      { field: 'totalBids', header: 'Total Bids (#)', showInHeader: true },
      { field: 'reserveMet', header: '% Reserve Met', showInHeader: true },
      { field: 'reservePrice', header: 'Reserve Price ($)', showInHeader: true },
      { field: 'edit', header: 'Action', showInHeader: true },
      { field: 'listStartDate', header: 'List Start Dt', showInHeader: false },
      { field: 'listEndDate', header: 'List End Dt', showInHeader: false },
      { field: 'bidders', header: 'Bidders', showInHeader: false },
      { field: 'views', header: 'views', showInHeader: false },
      { field: 'saves', header: 'saves', showInHeader: false },
      { field: 'initialReservePrice', header: 'Initial Reserve Price', showInHeader: false },
      { field: 'perInitialReservePrice', header: '% Initial reserve Price', showInHeader: false },
      { field: 'reservePriceReduction', header: 'Reserve price Reduction', showInHeader: false },
      { field: 'newReservePrice', header: 'New Reserve price', showInHeader: false },
      { field: 'startbid', header: 'start Bid', showInHeader: false },
      { field: 'requestStatus', header: 'Request Status', showInHeader: false },
      { field: 'origninalReservePrice', header: 'Original reserve price', showInHeader: false },
      { field: 'refreshState', header: 'Refresh state', showInHeader: false },
      { field: 'reservePriceChangedBy', header: 'Reserve price Changed By', showInHeader: false },
      { field: 'reservePriceChangedDate', header: 'Date/Time of Change', showInHeader: false },
      { field: 'counter', header: 'Counter', showInHeader: false },
      { field: 'counter$', header: 'Counter$', showInHeader: false },
      { field: 'errorMessage', header: 'errorMessage', showInHeader: false },
      { field: 'canEditReservePrice', header: 'Can Edit', showInHeader: false },
      { field: 'originalperInitialReservePrice', header:'', showInHeader:false},
      { field: 'originalnewReservePrice', header:'', showInHeader:false}
    ];
  }

  showChangeLogDialog() {
    this.dialogService.open(ChangeLogDetailsComponent, {
      header: 'Auction Change Log',
      contentStyle :{'width': '1000px','min-height':'400px', 'max-height': '600px','overflow-y':'scroll'}
    });
  }
 

  getData(): void {
    this.data = [];
    this.expandedRows = {};
    this.loading = true;
    this.disableSubmit = true;
    this.searchLabel = 'Searching..';
    this.auctionService.getAuctionData(this.reqRuestparams, this.paginationParams).subscribe(auctionData => {
      this.totalRecords = (<any>auctionData).meta.pagination.TotalRecords;
      this.data = auctionData.data;
      this.loading = false;
      this.searchLabel = 'Search';
      this.disableSubmit =  false;
      if (this.data.length > 0) {
        this.setDefaultRowexpansion();
        // create the form here for every row Object 
        this.data.forEach(element => {
          this.reservePriceUpdateForms.set(element.propertyId,
            new FormGroup({
              perInitialReservePrice: new FormControl({ value: '', disabled: true }, [Validators.minLength(1)]),
              newReservePrice: new FormControl({ value: '', disabled: true }, [Validators.minLength(1)]),
              reservePriceReduction: new FormControl({ value: '' }, [Validators.required, Validators.minLength(1), Validators.pattern(/^(\d*\.)?\d+$/)])
            }));
        });
        this.originalDataCopy = _.cloneDeep(this.data);
      }
    });
  }

  updateReservePriceForm(loanObject: LoanItem) {
    loanObject.updateRunning = true;
    let requestparms: ReservePriceUpdateRequestParams = {
      propertyId:loanObject.propertyId,
      loanNumber: loanObject.loan,
      auctionCycle: loanObject.auctionCycle,
      initialReservePricePercentageNew: loanObject.perInitialReservePrice != null ? Number(loanObject.perInitialReservePrice.toFixed(2)) : null,
      initialReservePricePercentageOld: loanObject.perInitialReservePriceOld,
      reservePriceReductionPercentageNew: loanObject.reservePriceReduction,
      reservePriceReductionPercentageOld: loanObject.reservePriceReductionOld,
      reservePriceNew: loanObject.newReservePrice,
      reservePriceOld: loanObject.reservePrice
    };
    loanObject.requestStatus = '';
    loanObject.errorMessage = '';
    this.auctionService.updateReservePriceAuctionData(requestparms).subscribe(response => {
      loanObject.updateRunning = false;
      if (response.data.length > 0) {
        loanObject.edit = false;
        loanObject.reservePriceChangedBy = response.data[0].UpdateOperatorName;
        loanObject.reservePriceChangedDate = response.data[0].UpdateDate;
        loanObject.requestStatus = response.data[0].UpdateStatusValue;
      }
    }, error => {
      loanObject.updateRunning = false;
      loanObject.requestStatus = 'Request Failed';
      loanObject.errorMessage = ': Internal error occurred.';
    });
  }

  refreshData(rowObject: LoanItem): void {
    this.reqRuestparams = <AuctionRequestParams>{};
    this.reqRuestparams.loan = rowObject.loan;
    this.reqRuestparams.reservepriceOptions = '';
    rowObject.refreshState = true;
    this.auctionService.getAuctionData(this.reqRuestparams, this.paginationParams).subscribe(loanData => {
      loanData.data.map(item => {
        if (item.propertyId == rowObject.propertyId) {
          rowObject.refreshState = false;
          rowObject = Object.assign(rowObject, item);
        }
      });
    }), error => {
      console.log(error);
    };
  }

  getReservePriceUpdateForm(propertyId: number) {
    return this.reservePriceUpdateForms.get(propertyId);
  }

  // Keeping tis code commented as it might be required in future
  // enableForm(rowObject: LoanItem, expanded: any) {
  //   expanded == false ? rowObject.edit = true : rowObject.edit = false;
  // }

  enableForm(rowObject: LoanItem, expanded: any) {
    if(expanded){
      rowObject.edit = true;
    }
    else{
      this.expandedRows[rowObject.propertyId] = 1;
      rowObject.edit = true;
    }
  }

  disableForm(rowObject: LoanItem) {
    rowObject.edit = false;
    this.originalDataCopy.map(item => {
      if (item.propertyId == rowObject.propertyId) {
        rowObject.reservePriceReduction = item.reservePriceReduction;
        rowObject.newReservePrice = item.newReservePrice;
        rowObject.perInitialReservePrice = item.perInitialReservePrice;
      }
    });
  }

  onPage(event): void {
    this.paginationParams = {
      offset: (event.first !== undefined ? event.first : this.paginationParams.offset)
      , pageSize: (event.rows !== undefined ? event.rows : this.paginationParams.pageSize)
      , sortDir: (event.sortOrder === 1 || event.sortOrder === 'Asc') ? 'Asc' : 'Desc'
      , sortValue: event.sortField ? event.sortField : 'LoanNumber'
    };

    this.getData();
  }

  // setting to show expandedd rows based on isProcessing  
  setDefaultRowexpansion(): void {
    const thisRef = this;
    this.data.map(loanItem => {
      loanItem.requestStatus === 'Request Pending' ? thisRef.expandedRows[loanItem.propertyId] = 1 : null;
    });
  }

 
  calculatefields(recordObj: LoanItem): void {
    let reservePriceReduction = this.getReservePriceUpdateForm(recordObj.propertyId).get('reservePriceReduction').value;
    recordObj.reservePriceReductionError = false;
    if(reservePriceReduction == 0 && reservePriceReduction != ''){
      recordObj.reservePriceReductionError = true;
      recordObj.reservePriceReduction = 0;
      return;
    }
    if(reservePriceReduction > 100){
      recordObj.reservePriceReduction = null;
      recordObj.reservePriceReductionError = true;
      recordObj.perInitialReservePrice = recordObj.originalperInitialReservePrice;
      recordObj.newReservePrice = recordObj.originalnewReservePrice;
      return;
    }
    if (reservePriceReduction != null && reservePriceReduction != 0 && Number(reservePriceReduction)
      && recordObj.initialReservePrice != null && recordObj.initialReservePrice != 0) {
      let reservePriceComputed = recordObj.originalReservePrice - (Math.abs((recordObj.originalReservePrice * reservePriceReduction) / 100));
      let perInitialReservePriceComputed = (reservePriceComputed / recordObj.initialReservePrice)*100;
      recordObj.perInitialReservePrice = perInitialReservePriceComputed;
      recordObj.newReservePrice = reservePriceComputed;
    }
    else if((reservePriceReduction == null || reservePriceReduction == 0) && recordObj.initialReservePrice != null && recordObj.initialReservePrice != 0) {
      if(recordObj.requestStatus !== 'Request Complete' || recordObj.requestStatus == null){
        recordObj.perInitialReservePrice = recordObj.originalperInitialReservePrice;
        recordObj.newReservePrice = recordObj.originalnewReservePrice;
      } else{
        recordObj.newReservePrice = null;
        recordObj.perInitialReservePrice = recordObj.originalperInitialReservePrice;
      }
    }
  }

  numbersOnly(e, rowData): boolean {
    let regx = /^[0-9]*[.]?[0-9]*$/;
    let char = String.fromCharCode(e.keyCode);

    if (regx.test(char)) {
      if (rowData.reservePriceReduction != null && char == '.' && rowData.reservePriceReduction.includes('.')) {
        return false;
      }
      return true;
    } else {
      return false;
    }
  }

  validateReservePriceRange(): void {
    this.rangeError = false;
    if (this.minReservePrice !== undefined && this.maxReservePrice !== undefined) {
      Number(this.minReservePrice) > Number(this.maxReservePrice) ? this.rangeError = true : this.rangeError = false;
    }
  }

  setReversePriceparams(): void {
    this.setEqualsCriteria = false;
    this.setRangeCriteria = false;
    // Delete  the control if exists.
    this.removeControls();
    this.reservePriceRangeSelected == '=' ? this.setFieldsForEquals() : (this.reservePriceRangeSelected == 'R' ? this.setFieldsForRange() : (this.reservePriceRangeSelected == '' ? this.setValidationForLoan() : null));
  }

  setFieldsForEquals(): void {
    this.setEqualsCriteria = true;
    this.rangeError = false;
    // Add the control dynamically.
    this.addControlsToForm('exactReservePriceForm', this.auctionForm);
    this.clearValidationForLoan();
  }

  setFieldsForRange(): void {
    this.setRangeCriteria = true;
    // Add the controls dynamically.
    this.addControlsToForm('minReservePriceForm', this.auctionForm);
    this.addControlsToForm('maxReservePriceForm', this.auctionForm);
    delete this.minReservePrice;
    delete this.maxReservePrice;
    this.clearValidationForLoan();
  }

  addControlsToForm(fieldname: string, form: FormGroup) {
    form.addControl(fieldname, new FormControl('', [Validators.required, Validators.minLength(1)]));
  }

  removeControls(): void {
    this.auctionForm.removeControl('exactReservePriceForm');
    this.auctionForm.removeControl('minReservePriceForm');
    this.auctionForm.removeControl('maxReservePriceForm');
  }

  clearValidationForLoan(): void {
    this.auctionForm.get('ReservepriceOptions').setValidators([Validators.required]);
    this.auctionForm.get('ReservepriceOptions').updateValueAndValidity();
    this.auctionForm.controls['loan'].clearValidators();
    this.auctionForm.controls['loan'].updateValueAndValidity();
    this.auctionForm.updateValueAndValidity();
  }

  setValidationForLoan(): void {
    this.auctionForm.get('loan').setValidators([Validators.required]);
    this.auctionForm.get('loan').updateValueAndValidity();
    this.auctionForm.controls['ReservepriceOptions'].clearValidators();
    this.auctionForm.controls['ReservepriceOptions'].updateValueAndValidity();
    this.auctionForm.updateValueAndValidity();
  }

  clearValidationForReservePrice(): void {
    this.auctionForm.get('loan').value.length > 0 ? this.setValidationForLoan() : (this.auctionForm.get('loan').value.length == 0 ? this.clearValidationForLoan() : null);
  }

  onSubmit() {
    // take the form parameter and pass it to the API
    // console.log(reqRuestparams);
    this.paginationParams = { offset: 0, pageSize: 10, sortValue: 'LoanNumber', sortDir: 'Asc' };
    if(this.table != undefined)
    this.table.first = 1;
    this.setRequestParams();
    this.getData();
  }

  setRequestParams(): void {
    // let reqRuestparams = <AuctionRequestParams> {};
    this.reqRuestparams.loan = this.auctionForm.value.loan
    this.reqRuestparams.reservepriceOptions = this.auctionForm.value.ReservepriceOptions;
    this.reqRuestparams.minReservePrice = this.auctionForm.value.minReservePriceForm != (undefined || null) ? this.auctionForm.value.minReservePriceForm : '';
    this.reqRuestparams.maxReservePrice = this.auctionForm.value.maxReservePriceForm != (undefined || null) ? this.auctionForm.value.maxReservePriceForm : '';
    this.reqRuestparams.exactReservePrice = this.auctionForm.value.exactReservePriceForm != (undefined || null) ? this.auctionForm.value.exactReservePriceForm : '';
    this.mainSearchParams = this.reqRuestparams;
  }

}


